import React from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import { Button } from 'ui-components/components/button';
import { Modal } from 'ui-components/components/modal';
import { ModalHeader } from 'ui-components/components/modal/modal-header';
import { ModalBody } from 'ui-components/components/modal/modal-body';
import { ModalFooter } from 'ui-components/components/modal/modal-footer';
import { FormattedMessage } from 'react-intl';

import style from './subscription-required-modal.module.less';

export const SubscriptionRequiredModal = ({ modalFrameworkMethods }) => (
  <Modal>
    <ModalHeader closeModal={modalFrameworkMethods.closeModal}>
      <FormattedMessage defaultMessage='Subscription Required' description='SubscriptionRequiredModal.header' id='UfeMkw' />
    </ModalHeader>
    <ModalBody className={style.body}>
      <div>
        <FormattedMessage
          defaultMessage='An active subscription is required to create shipments. Please click <link>here</link> to update your account.'
          description='SubscriptionRequiredModal.message'
          id='5wXUI3'
          values={{
            link: (chunks) => <Link to='/settings/payments'>{chunks}</Link>,
          }}
        />
      </div>
    </ModalBody>
    <ModalFooter>
      <Button onClick={modalFrameworkMethods.closeModal} theme='primary'>
        <FormattedMessage defaultMessage='Close' description='confirm' id='XQIob/' />
      </Button>
    </ModalFooter>
  </Modal>
);

SubscriptionRequiredModal.propTypes = {
  modalFrameworkMethods: PropTypes.object.isRequired,
};
